import { useEffect, useState } from "react";

export const useIsPortrait = () => {
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  const orientationHandler = (event: any) => {
    setIsPortrait(event.matches);
  };

  useEffect(() => {
    const orientationQuery = window.matchMedia("(orientation: portrait)");
    orientationQuery.addEventListener("change", orientationHandler);

    return () => {
      orientationQuery.removeEventListener("change", orientationHandler);
    };

  }, []);

  return isPortrait;
};
